<template>
  <div>
    <v-card class="white rounded-lg" v-if="user.business_token">
      <v-card-title class="secondary--text">{{title}}
      <v-spacer></v-spacer>
        <v-btn
            large
            depressed
            class="receipt rounded-lg float-left"
            color="success"
            @click="setAffiliateForSaleProducts">ثبت</v-btn>
      </v-card-title>
      <v-card-text>
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     ref="datatable" :show-select="true">

        </m-datatable>
      </v-card-text>
    </v-card>
    <v-card class="white rounded-lg" v-else>
      <v-card-title class="error white--text">کسب و کار فعال نیست
      </v-card-title>
    </v-card>

  </div>

</template>

<script>
export default {
  name: "SelectAffiliateProductsForSale",
  components: {},
  props: {},
  data() {
    return {
      url: "product/product/all",
      filters: {},
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('انتخاب محصولات برای فروش در کسب و کار')
    },

    headers() {
      return [
        {
          text: "شناسه محصول",
          value: "product_id",
        },
        {
          text: "نام محصول",
          value: "name",
          width: 300,
          max_length: 100
        },
        {
          text: "بارکد",
          value: "barcode",
        },
        {
          text: "موجودی ",
          value: "inventory",
        },
        {
          text: "قیمت",
          value: "price",
          type: 'numeric'
        },
        {
          text: "دسته بندی",
          value: "category.name",
          width: 300,
          max_length: 100

        },
        {
          text: "برند",
          value: "brand_name",
          width: 150,
          max_length: 100

        },
        {
          text: "کشور تولید",
          value: "made_in",
        },
      ];

    },
  },
  mounted() {
    if (this.user.business_token) {
      this.getAffiliateForSaleProducts()
    }
  },
  methods: {
    getAffiliateForSaleProducts(){
      this.request({
        url: this.endpoint(`product/affiliateForSaleProducts?businessToken=${this.user.business_token}`),
        method: "get",
        success: data => {
          this.$refs.datatable.selectedValues = data
        }
      })

    },
    setAffiliateForSaleProducts(){
      let request_data = []
      for (let product of this.$refs.datatable.selectedItems) {
        request_data.push(product.id)
      }
      this.request({
        url: this.endpoint(`product/affiliateProductAddBusiness?businessToken=${this.user.business_token}`),
        method: "put",
        data: request_data,
        success: data => {
          this.successNotify()
          this.getAffiliateForSaleProducts()
        }
      })

    },

  },
};
</script>

<style scoped lang="scss">
</style>